import React from 'react';

import { Info } from 'lucide-react';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/atoms/Tooltip';
import { cn } from '@/helpers/shadCnUtils';

interface TooltipIconProps {
  tooltipContent: string;
  className?: string;
  triggerClassName?: string;
  warning?: boolean;
  side?: 'top' | 'right' | 'bottom' | 'left';
}

const TooltipIcon: React.FC<TooltipIconProps> = React.memo(
  ({ tooltipContent, className, triggerClassName, warning, side = 'top' }) => (
    <TooltipProvider>
      <Tooltip delayDuration={0}>
        <TooltipTrigger asChild>
          <Info
            className={cn('size-3.25 cursor-pointer text-gray-400', warning && 'text-yellow-500', triggerClassName)}
          />
        </TooltipTrigger>

        <TooltipContent side={side} sideOffset={8} className={cn('max-w-56 bg-gray-50', className)}>
          <p className="text-xs text-gray-800">{tooltipContent}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  ),
);

export default TooltipIcon;
